<template>
    <div class="w-full bg-gray max-md:py-3 md:p-3">
        <ul class="w-full flex flex-row md:justify-center max-md:pl-4 max-md:pr-4 max-md:flex max-md:overflow-scroll uppercase">
            <li v-for="(filter, index) in filters" :key="index" class="text-sm max-md:inline-block shrink-0">
                <button @click="setFilter(index)" :class="{'border-black': filterIndex == index, 'border-transparent': filterIndex != index}" class="py-1 px-5 md:px-7 border-[2px] rounded-full">{{filter.title}}</button>
            </li>
        </ul>
    </div>
</template>

<script setup>
const router = useRouter()
const route = useRoute();

const props = defineProps({
    events: {
        type: Array,
        required: true
    }
})

const filters = ref(null)

const filterIndex = ref(0)

const setFilter = (index) => {
    filterIndex.value = index
}

watch(filterIndex, (index) => {
    if (index !== 0) {
        const selectedFilter = filters.value[index]
        router.push({ query: { category: selectedFilter.slug } })
    } else {
        router.push({ query: null })
    }
})

onMounted(() => {    
    let setFilters = [{'title': 'Alle', 'slug': 'all'}]
    props.events.forEach(event => {
        event.category.forEach(category => {
            const exists = setFilters.some(filter => filter.slug === category.slug)
            if (!exists) {
                setFilters.push({...category})
            }
        })
    })

    filters.value = setFilters

    if (route.query.category) {
        const selectedFilter = filters.value.findIndex(filter => filter.slug === route.query.category)
        filterIndex.value = selectedFilter
    }
})  
</script>